import { Component, Input } from '@angular/core';
import { IMenuItem } from '../../services/navigation.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html'
})
export class SidenavComponent {
  @Input('items') public menuItems: IMenuItem[] = [];
  @Input('hasIconMenu')
  public hasIconTypeMenuItem!: boolean;
  @Input('iconMenuTitle') public iconTypeMenuTitle!: string;
  isWarningNotification: boolean = false;
  isForceNotification: boolean = false;

  constructor(private cookieService: CookieService,) {
    this.isWarningNotification = this.cookieService.check("isWarningNotification") ? JSON.parse(this.cookieService.get("isWarningNotification")) : false;
    this.isForceNotification = this.cookieService.check("isForceNotification") ? JSON.parse(this.cookieService.get("isForceNotification")) : false;
    console.log('Found Menus !',this.menuItems);
    this.addMenuItem();
  }
  
  // Only for demo purpose
  addMenuItem() {
    this.menuItems.push({
      name: 'ITEM',
      type: 'dropDown',
      tooltip: 'Item',
      icon: 'done',
      state: 'material',
      sub: [
        { name: 'SUBITEM', state: 'cards' },
        { name: 'SUBITEM', state: 'buttons' }
      ],
      action: null
    });
  }
}